import Axios from 'axios'

export default {
  state: {
    coachs: [],
    coach: null,
    requests: []
  },
  getters: {
    coachs(state) {
      return state.coachs
    },
    requests(state) {
      return state.requests
    },
    getCoachById: (state) => {
      return state.coach
    }
  },
  mutations: {
    setCoachs(state, payload) {
      state.coachs = payload;
    },
    setCoach(state, payload) {
      state.coach = payload;
    },
    setRequests(state, payload) {
      state.requests = payload;
    },
    clearCoach(state) {
      state.coach = null
    }
  },
  actions: {
    getPack: async ({ commit }, payload) => {
      commit('setLoading')
      return await Axios.get(`${process.env.VUE_APP_API_URL_COACHS_ROUTE}pack/${payload}`)
        .then(res => {
          commit('setLoading')
          if (res.request.status != 200)
            throw new Error(res.data)
          else {
            return res.data.data
          }
        }
        ).catch(error => {
          commit('clearError')
          commit('setError', error)
        })

    },
    getCoachs: async ({ commit }) => {
      commit('setLoading')
      await Axios.get(process.env.VUE_APP_API_URL_COACHS)
        .then(res => {
          if (res.data.status != 200)
            res.data = []
          commit('setCoachs', res.data.data)
          commit('setLoading')
        }
        ).catch(error => {
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },
    getRequests: async ({ commit, getters }) => {
      commit('setLoading')
      await Axios.get(`${process.env.VUE_APP_API_URL_COACHING_REQUEST}${getters.user._id}`)
        .then(res => {
          if (res.request.status != 200)
            res.data = []
          commit('setRequests', res.data.data)
          commit('setLoading')
        }
        ).catch(error => {
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },
    repToRequest: async ({ commit, getters }, payload) => {
      commit('setLoading')
      await Axios.put(`${process.env.VUE_APP_API_URL_COACHING_REQUEST}${payload.reqId}`,
        { coach: getters.user._id, ...payload })
        .then(res => {
          commit('setRequests', [
            ...getters.requests.filter(element => element._id !== payload.reqId),
            res.data.data
          ])
          commit('setLoading')
        }
        ).catch(error => {
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },
    async loadCoachById({ commit }, payload) {
      commit('clearCoach')
      commit('setLoading')
      await Axios.get(process.env.VUE_APP_API_URL_COACH_BY_ID + payload)
        .then(res => {
          commit('setCoach', res.data.data)
          commit('setLoading')
        }
        ).catch(error => {
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },
    async updateCoach({ commit, getters }, payload) {
      commit('setLoading')
      await Axios.put(process.env.VUE_APP_API_URL_COACHS_ROUTE + getters.user.coach._id,
        payload)
        .then(res => {
          // commit('addDiploma', JSON.parse(JSON.stringify(res.data.data.diploma)));
          commit('setLoading')
          // commit('setMessageSuccess', "Votre diplome a été enregisté avec succées");
        }
        ).catch(error => {
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },
    async recommendedCoachs({ commit, getters }) {
      return await Axios.get(`${process.env.VUE_APP_API_URL_COACHS_ROUTE}/recommand/${getters.user._id}`)
        .then(res => {
          if (res.data.success)
            return res.data.data;
          else throw new Error(res.data.message)
        })
        .catch(error => {
          commit('clearError')
          commit('setError', error)
        })

    }
  }
}
